import React from 'react';
import { SPACE } from './CommonConstants';

export const NO_GROUPS_MESSAGE =
    'No groups have been formed. Please assess your students to get group recommendations.';

export const UPDATE_RECOMMENDATIONS_TEXT = 'Update Recommendations';
export const UPDATE_RECOMMENDATION_TEXT_HISTORICAL = 'View Latest';

const FIRST_TIME_VISIT_MESSAGE = (
    <>
        The first time you visit this page, groups are automatically generated based on the latest
        available assessment data.
    </>
);

const OBSERVATION_MESSAGE = (
    <>
        <br />
        <br />
        The observed patterns noted for the group are the specific behaviors displayed by students
        in the group, which helps to further target instruction.
    </>
);

export const getGroupsMessage = (withObservations, withPmResults, isSecure) => {
    if (isSecure) {
        return (
            <>
                To view a previous set of instructional groups, select them from the{' '}
                <strong>Past Updates</strong> list.
                {withObservations && OBSERVATION_MESSAGE}
            </>
        );
    }
    return withPmResults ? (
        <>
            {FIRST_TIME_VISIT_MESSAGE} To update your groups based on additional benchmark or
            progress monitoring results, click <strong>{UPDATE_RECOMMENDATIONS_TEXT}.</strong> To
            view a previous set of instructional groups, select them from the{' '}
            <strong>Past Updates</strong> list.
            {withObservations && OBSERVATION_MESSAGE}
        </>
    ) : (
        <>
            {FIRST_TIME_VISIT_MESSAGE} To update your groups based on additional benchmark results,
            click <strong>{UPDATE_RECOMMENDATIONS_TEXT}.</strong> To view a previous set of
            instructional groups, select them from the <strong>Past Updates</strong> list.
        </>
    );
};

export const getGroupsHistoricalMessage = (withObservations, isSecure) => (
    <>
        {!isSecure && FIRST_TIME_VISIT_MESSAGE}
        <br />
        When you finish reviewing your previous groups, click {SPACE}
        <strong>{UPDATE_RECOMMENDATION_TEXT_HISTORICAL}</strong> to view the most recent
        instructional groups again.
        {withObservations && OBSERVATION_MESSAGE}
    </>
);

export const SWITCH_TO_PREVIOUS_RECOMMENDATIONS_DELAY = 500;

export const KEYS = {
    MEASURE: 'measure',
    OBSERVATIONS: 'observations',
};

export const RULE_SET = {
    DEFAULT_RULES: 'rules',
    SINGLE_MEASURE_RULES: 'singleMeasureRules',
    TRC_RULES: 'trcRules',
};

export const INSTRUCTION_GROUPS_TYPES = {
    READING: 'READING',
    ESPANOL: 'ESPANOL',
};

export const TBL_KEYS = {
    NAME: 'Name',
    OVERALL: 'OVERALL',
    TRC: 'TRC',
    TRO: 'TRO',
    DO: 'DO',
};

export const TBL_COLUMN_TITLES = {
    [TBL_KEYS.NAME]: 'Name',
    [TBL_KEYS.OVERALL]: 'Composite',
    [TBL_KEYS.TRC]: 'TRC',
    [TBL_KEYS.TRO]: 'TRO',
    [TBL_KEYS.DO]: 'DO',
};
